import React, { useState } from 'react';
import { IconHelpCircle } from 'svgIcons/MotionPortalIcons';
import Tippy from '@tippy.js/react';
import { translate } from 'helpers/translateHelper';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import IconEchartZoom from 'svgIcons/MotionPortalIcons/IconEchartZoom';
import IconEchartRotate from 'svgIcons/MotionPortalIcons/IconEchartRotate';
import IconEchartPan from 'svgIcons/MotionPortalIcons/IconEchartPan';

const EchartHelpInfo = () => {
    const [show, setShow] = useState(false);

    const approveHandler = () => {
        setShow(false);
    };

    const tippyContent = () => <div className='echart-help-info-popover'>
        {translate('ABB.Powertrain.Frontend.fftEchartInfoLabel')}
    </div>;

    return (
        <div className='echart-info-panel'>
            <Tippy
                content={tippyContent()}
                interactive={true}
                interactiveBorder={10}
                animation='scale'
                theme='light-border'
                trigger='mouseenter'
                placement='top'
            >
                <button
                    className='info-tippy-content'
                    onClick={() => setShow(true)}
                    type='button'>
                    <IconHelpCircle />
                </button>
            </Tippy>
            <GeneralDialog
                modalClassName='echart-help-info-modal'
                show={show}
                title={
                    <>
                        <IconHelpCircle />
                        {translate('ABB.Powertrain.Frontend.fftEchartInfoTitle')}
                    </>

                }
                acceptButtonProps={{
                    text: translate('ABB.Powertrain.Frontend.fftEchartGotItBtn'),
                    onClick: approveHandler
                }}
                persistent
                id='echart-help-info-modal'

            >
                <div className='info-content'>
                    <div className='content-item'>
                        <IconEchartZoom />
                        <div className='content-text'>
                            <label>{translate('ABB.Powertrain.Frontend.fftEchartInfoZoom')}</label>
                            <span>{translate('ABB.Powertrain.Frontend.fftEchartInfoZoomContent')}</span>
                        </div>
                    </div>
                    <div className='content-item'>
                        <IconEchartRotate />
                        <div className='content-text'>
                            <label>{translate('ABB.Powertrain.Frontend.fftEchartInfoRotate')}</label>
                            <span>{translate('ABB.Powertrain.Frontend.fftEchartInfoRotateContent')}</span>
                        </div>
                    </div>
                    <div className='content-item'>
                        <IconEchartPan />
                        <div className='content-text'>
                            <label>{translate('ABB.Powertrain.Frontend.fftEchartInfoPan')}</label>
                            <span>{translate('ABB.Powertrain.Frontend.fftEchartInfoPanContent')}</span>
                        </div>
                    </div>
                </div>
            </GeneralDialog>
        </div>
    );
};

export default EchartHelpInfo;
